export class ImageSize {
  static readonly ORIGINAL = 'original'
  static readonly XL = 'xl'
  static readonly LG = 'lg'
  static readonly MD = 'md'
  static readonly SM = 'sm'
  static readonly XS = 'xs'
}
